export interface HealthCheckLike {
  health_check_id?: string;
  id?: string;
  status?: string;
  HealthCheck?: {
    ProbeHealthCheck?: {
      probe?: {
        args?: {
          port?: string | number;
        };
      };
    };
  };
  probe_health_check?: {
    probe?: {
      args?: {
        port?: string | number;
      };
    };
  };
}

export const getHealthCheckProbePort = (
  healthCheck: HealthCheckLike | undefined,
): string | undefined => {
  const port =
    healthCheck?.HealthCheck?.ProbeHealthCheck?.probe?.args?.port ??
    healthCheck?.probe_health_check?.probe?.args?.port;
  return port == null ? undefined : String(port);
};

export const getHealthCheckIdentity = (
  healthCheck: HealthCheckLike,
): string | undefined => {
  const port = getHealthCheckProbePort(healthCheck);
  if (port) return `port:${port}`;

  const id = healthCheck.health_check_id ?? healthCheck.id;
  return id == null ? undefined : `id:${id}`;
};

export const getHealthCheckStatusKey = (
  healthCheck: HealthCheckLike,
): string => {
  const identity = getHealthCheckIdentity(healthCheck);
  const status = healthCheck.status ?? "";
  return identity ? `${identity}:status:${status}` : `unkeyed-status:${status}`;
};
